import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
// create slice

const name = "changePassword";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const changePasswordActions = { ...slice.actions, ...extraActions };
export const changePasswordReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state
    changedpassword: [],
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    clearpassword,
  };
// clear the response
  function clearpassword(state) {
    state.changedpassword = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/User`;
  return {
    ChangePassword: ChangePassword(),
  };

  function ChangePassword() {
    return createAsyncThunk(
      `${name}/ChangePassword`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/ChangePassword`, params)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.ChangePassword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.ChangePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.changedpassword = action.payload;
    })
    .addCase(extraActions.ChangePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
